import React from 'react'
import ReactDOM from 'react-dom'

import { unregister } from './utils/setup/serviceWorker'
import ReactWrapper from './utils/contexts/ReactWrapper'

const App = () => <ReactWrapper />

ReactDOM.render(<App />, document.getElementById('root'))
unregister()
